import type core from '@babel/core';

export type Core = typeof core;
